export const documentProps = {
  title: 'Executive Dashboard — Your Entire Business on One Screen',
  description:
    'Real-time KPIs, AI-generated weekly summaries, and integrations with QuickBooks, HubSpot, and Stripe. Stop running your business from spreadsheets.',
};
